var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E2DE",
    fillRule: "evenodd",
    d: "M7.83 0c3.78 0 6.935 2.52 7.67 5.87C16.235 2.52 19.389 0 23.169 0 27.494 0 31 3.298 31 7.367c0 2.034-.877 3.876-2.294 5.21L15.5 25 2.294 12.576C.877 11.243 0 9.401 0 7.367 0 3.298 3.506 0 7.83 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0a3211d578372e358c7647731499f8dc.svg";
export { ForwardRef as ReactComponent };